import { render, staticRenderFns } from "./IntentDetail.vue?vue&type=template&id=78c70cd8&scoped=true"
import script from "./IntentDetail.vue?vue&type=script&lang=js"
export * from "./IntentDetail.vue?vue&type=script&lang=js"
import style0 from "./IntentDetail.vue?vue&type=style&index=0&id=78c70cd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c70cd8",
  null
  
)

export default component.exports